/**
 * Serakia PDP gallery — mobile swipe/tap + dots; desktop mosaic scroll-spy + dots
 */
(function () {
  const MQ = window.matchMedia('(min-width: 750px)');

  function initGallery(root) {
    if (!root || root.dataset.skGalleryReady === '1') return;
    root.dataset.skGalleryReady = '1';

    const list = root.querySelector('.sk-gallery__list');
    if (!list) return;

    let active = 0;

    const slides = () => Array.from(list.querySelectorAll(':scope > .sk-gallery__item'));
    const dots = () => Array.from(root.querySelectorAll('.sk-gallery__dot'));

    const setActive = (index, { scroll = false, behavior = 'smooth' } = {}) => {
      const items = slides();
      if (!items.length) return;
      const i = Math.max(0, Math.min(index, items.length - 1));
      active = i;

      items.forEach((el, n) => el.classList.toggle('is-active', n === i));
      dots().forEach((dot, n) => {
        const on = n === i;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      if (!scroll) return;
      const target = items[i];
      if (!target) return;

      if (MQ.matches) {
        const y = target.getBoundingClientRect().top + window.scrollY - 88;
        window.scrollTo({ top: y, behavior });
      } else {
        list.scrollTo({ left: target.offsetLeft, behavior });
      }
    };

    root.addEventListener('click', (e) => {
      const dot = e.target.closest('.sk-gallery__dot');
      if (!dot || !root.contains(dot)) return;
      setActive(Number(dot.dataset.skDot), { scroll: true });
    });

    /* Mobile only: tap left/right half to change slide (additive to swipe + dots) */
    const TAP_SLOP = 10;
    const INTERACTIVE_SEL =
      'a[href], button:not(.product__media-toggle), summary, input, select, textarea, label, [role="button"]:not(.product__media-toggle), .deferred-media__poster, .product__xr-button, .sk-gallery__dot, .product__media-icon';

    let pointerStart = null;
    let suppressZoomClick = false;

    /* Mobile only: press-and-hold auto-advances through images; release stays on current */
    const HOLD_DELAY = 300;
    const HOLD_INTERVAL = 1400;
    let holdDelayTimer = null;
    let holdTimer = null;
    let holding = false;

    const holdStep = () => {
      const items = slides();
      if (items.length < 2) return;
      setActive((active + 1) % items.length, { scroll: true });
    };

    const cancelHold = () => {
      clearTimeout(holdDelayTimer);
      holdDelayTimer = null;
      clearInterval(holdTimer);
      holdTimer = null;
      if (holding) root.classList.remove('is-holding');
      holding = false;
    };

    const isHoldTarget = (el) => el && list.contains(el) && !el.closest(INTERACTIVE_SEL);

    const advanceByTap = (clientX) => {
      const items = slides();
      if (items.length < 2) return false;
      const rect = list.getBoundingClientRect();
      if (rect.width < 1) return false;
      const delta = clientX - rect.left < rect.width / 2 ? -1 : 1;
      const next = (active + delta + items.length) % items.length;
      setActive(next, { scroll: true });
      return true;
    };

    list.addEventListener(
      'pointerdown',
      (e) => {
        if (MQ.matches) return;
        if (e.isPrimary === false) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        pointerStart = { id: e.pointerId, x: e.clientX, y: e.clientY, target: e.target, held: false };
        suppressZoomClick = false;

        cancelHold();
        if (e.pointerType !== 'touch' || !isHoldTarget(e.target) || slides().length < 2) return;
        const start = pointerStart;
        holdDelayTimer = setTimeout(() => {
          holdDelayTimer = null;
          holding = true;
          start.held = true;
          root.classList.add('is-holding');
          holdStep();
          holdTimer = setInterval(holdStep, HOLD_INTERVAL);
        }, HOLD_DELAY);
      },
      { passive: true }
    );

    list.addEventListener(
      'pointermove',
      (e) => {
        if (!pointerStart || pointerStart.id !== e.pointerId || holding || !holdDelayTimer) return;
        if (Math.abs(e.clientX - pointerStart.x) > TAP_SLOP || Math.abs(e.clientY - pointerStart.y) > TAP_SLOP) {
          cancelHold();
        }
      },
      { passive: true }
    );

    list.addEventListener('contextmenu', (e) => {
      if (holding || holdDelayTimer) e.preventDefault();
    });

    list.addEventListener(
      'pointerup',
      (e) => {
        if (MQ.matches || !pointerStart || pointerStart.id !== e.pointerId) return;
        const start = pointerStart;
        pointerStart = null;
        cancelHold();

        if (start.held) {
          /* Hold already changed the image — don't also tap-advance or open zoom */
          suppressZoomClick = true;
          e.preventDefault();
          return;
        }

        const dx = Math.abs(e.clientX - start.x);
        const dy = Math.abs(e.clientY - start.y);
        if (dx > TAP_SLOP || dy > TAP_SLOP) return;

        const hit = start.target;
        if (!hit || !list.contains(hit)) return;
        if (hit.closest(INTERACTIVE_SEL)) return;

        const onZoomToggle = hit.closest('.product__media-toggle');
        if (onZoomToggle) {
          /* Full-bleed Dawn zoom hit-area — advance instead of opening lightbox */
          e.preventDefault();
          e.stopPropagation();
          suppressZoomClick = true;
        }

        advanceByTap(e.clientX);
      },
      { passive: false }
    );

    list.addEventListener(
      'pointercancel',
      (e) => {
        if (pointerStart && pointerStart.id === e.pointerId) pointerStart = null;
        cancelHold();
      },
      { passive: true }
    );

    list.addEventListener(
      'click',
      (e) => {
        if (!suppressZoomClick) return;
        if (e.target.closest('.product__media-toggle') || e.target.closest('.sk-gallery__item')) {
          e.preventDefault();
          e.stopPropagation();
        }
        suppressZoomClick = false;
      },
      true
    );

    list.addEventListener(
      'scroll',
      () => {
        if (MQ.matches) return;
        const items = slides();
        if (!items.length) return;
        const mid = list.scrollLeft + list.clientWidth / 2;
        let best = 0;
        let bestDist = Infinity;
        items.forEach((el, n) => {
          const c = el.offsetLeft + el.clientWidth / 2;
          const d = Math.abs(c - mid);
          if (d < bestDist) {
            bestDist = d;
            best = n;
          }
        });
        if (best !== active) setActive(best);
      },
      { passive: true }
    );

    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (!MQ.matches) return;
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const items = slides();
          if (!items.length) return;
          const marker = window.innerHeight * 0.38;
          let best = 0;
          let bestDist = Infinity;
          items.forEach((el, n) => {
            const r = el.getBoundingClientRect();
            if (r.height < 1) return;
            const c = r.top + r.height / 2;
            const d = Math.abs(c - marker);
            if (d < bestDist) {
              bestDist = d;
              best = n;
            }
          });
          if (best !== active) setActive(best);
        });
      },
      { passive: true }
    );

    const rebuildDots = () => {
      const wrap = root.querySelector('.sk-gallery__dots');
      const items = slides();
      if (!wrap || items.length < 2) {
        if (wrap) wrap.hidden = items.length < 2;
        return;
      }
      wrap.hidden = false;
      if (wrap.children.length === items.length) return;
      wrap.innerHTML = items
        .map(
          (_, n) =>
            `<button type="button" class="sk-gallery__dot${n === active ? ' is-active' : ''}" role="tab" data-sk-dot="${n}" aria-selected="${n === active}" aria-label="Image ${n + 1}"></button>`
        )
        .join('');
    };

    new MutationObserver(rebuildDots).observe(list, { childList: true });

    root._skSetActive = (mediaId) => {
      const idx = slides().findIndex((el) => el.dataset.mediaId === mediaId);
      if (idx >= 0) setActive(idx, { scroll: true, behavior: 'auto' });
    };

    customElements.whenDefined('media-gallery').then(() => {
      if (root._skPatched) return;
      root._skPatched = true;
      const original = root.setActiveMedia?.bind(root);
      root.setActiveMedia = (mediaId, prepend) => {
        if (typeof original === 'function') original(mediaId, prepend);
        root._skSetActive?.(mediaId);
      };
    });
  }

  function boot() {
    document.querySelectorAll('media-gallery.sk-gallery').forEach((el) => {
      if (el.dataset.skGalleryReady === '1') return;
      initGallery(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target?.querySelectorAll?.('media-gallery.sk-gallery').forEach((el) => {
      el.dataset.skGalleryReady = '';
      initGallery(el);
    });
  });
})();
